// extracted by mini-css-extract-plugin
module.exports = {"iconsGroup":"ApplicationsTabMenu_iconsGroup__MtJQy","icon":"ApplicationsTabMenu_icon__2gPGg"};